export class Pagination {
    constructor(public columnName = "", public ascending = true, 
    public pageIndex = 1, public pageLength = 50, 
    public searchText = "", public clientMasterId = 0,
     public isDeleted = false, public sourceUrl = null, 
     public masterSheetId = null, public regionId = null, 
     public countryId = null, public jurisdictionId = null, 
     public regulatorId = null, public docTypeId = null, 
     public clientFacing:any = null, public regLakeStatusId = null, 
     public threshold = null, public updateTypeId = null, 
     public languageId = null, public monitoringDate = null, 
     public industryId = null, public assigneeId = null, 
     public searchString = null,public startDate=null,
     public endDate=null,public docName=null,
     public documentURL=null,public cmsId=null,
    public rLRecordStatus=null,
    public ruleTypeId = null,
    public createdOn = null,
    public missedActionDataValidationID=null,
    public missedActionFileName =null,
    public missedActionDate=null,
    public missedActionStatus=null,
    public updatedOn=null,
    public URLConfigurationMasterID=null,
    public ClientName=null,
    public PushToCMS=null,
    public IsSeleniumRequired=null,
    public ProcessDate = null,
    public CrawledMasterDataID=null,
    public UrlDetailID=null,
    public CreatedOn=null,  
    public CrawledJSONID=null,
    public ErrorMessage=null,
    public SourceURLError=null,
    public FieldLevelError=null,
    public TotalReceivedRecords=null,
    public ProcessedRecords=null,
    public ErrorRecords=null,
    public BrowserType=null,
    public CrawledData=null,
    public PaginationXPath = null,
    public DoesDataExistOnSourceURL = null,
    public URLProcessDelayForCE = null,
    public ClickEventType = null,
    public NoOfRecordCrawlFromURL = null,
    public DropdownBox_Xpath = null,
    public VisibleText = null,
    public TranslatedPDFFileName = null,
    public URLDetailId = null,
    ) {
    }
}